//
// Google Maps JavaScript SDK:
// https://developers.google.com/maps/documentation/javascript/reference/
//

//
// Google Marker Clusterer SDK:
// https://googlemaps.github.io/js-markerclustererplus/index.html
//

(function() {
    angular
        .module("app")
        .factory("googleMapsService", googleMapsService)

    googleMapsService.$inject = [
        "$q",
        "$window",
        "$rootScope",
        "$filter",
        "imagesService",
        "messagePreviewService"
    ]

    function googleMapsService($q, $window, $rootScope, $filter, imagesService, messagePreviewService) {

        class MarkerLabel {

            constructor(latlng, device, display) {

                let top = -41
                let left = 23

                if (device.meta.isTrackerTrucksEnter) {
                    top = -36
                    left = 19
                }

                this.latlng    = latlng
                this.text      = device.name
                this.display   = display
                this.inCluster = false
                this.offset    = {
                    top: top,
                    left: left
                }
            }
        }

        const service = {}

        $window.googleMapsApiInstalled = () => {}

        let mapInstalled = false

        service.install = () => {

            if (!mapInstalled) {

                mapInstalled = true

                let script = document.createElement("script")
                script.type = "text/javascript"
                script.src = "https://maps.googleapis.com/maps/api/js?key=" + $rootScope.config.mapsAPIKey + "&callback=googleMapsApiInstalled"

                document.body.appendChild(script)

            }
        }

        let hasDefinedMarkers = false

        const defineMarkers = () => {

            if (!hasDefinedMarkers) {

                hasDefinedMarkers = true

                MarkerLabel.prototype = new google.maps.OverlayView()

                MarkerLabel.prototype.draw = function() {

                    const self = this

                    let div = this.div

                    if (!div) {

                        div = this.div = document.createElement("div")

                        div.style.position     = "absolute"
                        div.style.padding      = "5px"
                        div.style.background   = "#FFF"
                        div.style.border       = "1px solid #999"
                        div.style.borderRadius = "6px"
                        div.style.whiteSpace   = "nowrap"

                        if (!this.display) {
                            div.style.visibility = "hidden"
                        }

                        div.innerHTML = self.text

                        this.getPanes().overlayImage.appendChild(div)

                    }

                    let point = this.getProjection().fromLatLngToDivPixel(this.latlng)

                    if (point) {
                        div.style.left = point.x + this.offset.left + "px"
                        div.style.top = point.y + this.offset.top + "px"
                    }
                }

                MarkerLabel.prototype.hide = function() {
                    if (this.div && this.display) {
                        this.display = false
                        this.div.style.visibility = "hidden"
                    }
                }

                MarkerLabel.prototype.show = function() {
                    if (this.div && !this.display) {
                        this.display = true
                        this.div.style.visibility = "visible"
                    }
                }

                MarkerLabel.prototype.remove = function() {
                    if (this.div) {
                        this.div.parentNode.removeChild(this.div)
                        this.div = null
                    }
                }

                MarkerLabel.prototype.getPosition = function() {
                    return this.latlng
                }
            }
        }

        service.createMap = (mapID) => {

            let deferred = $q.defer()

            const resolve = () => {

                // 2022-04-07
                // Fix for deprecated markerclusterplus console warnings on new MarkerClusterer
                google.maps.event.addDomListener = (targ, ev, func, opts) => {
                    targ.addEventListener(ev, func, opts)
                }

                defineMarkers()

                const options = {
                    zoom:              2,
                    center:            new google.maps.LatLng(39.80368, -105.0428828),
                    mapTypeId:         google.maps.MapTypeId.ROADMAP,
                    scrollwheel:       true,
                    zoomControl:       true,
                    fullscreenControl: true,
                    streetViewControl: true
                }

                deferred.resolve(new google.maps.Map(document.getElementById(mapID), options))

            }

            if ($window.google && $window.google.maps) {

                resolve()

            } else {

                $window.googleMapsApiInstalled = resolve

            }

            return deferred.promise

        }

        const markerTemplate = [
            '<svg width="46px" height="52px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">',
            '<defs>',
            '<path id="p1" d="M6,13.7898616 C6.0801325,12.4463891 6.53007631,11.3498324 7.34983142,10.5001914 C8.16958653,9.65055039 9.2601026,9.1504866 10.6213796,9 L31.3768307,9 C32.7348814,9.23260838 33.7845041,9.73267217 34.5256988,10.5001914 C35.2668934,11.2677106 35.75913,12.3642673 36.0024085,13.7898616 L36.0024085,33.9862315 C35.8252519,35.3076248 35.3330153,36.3798243 34.5256988,37.2028299 C33.7183823,38.0258356 32.6687596,38.5254595 31.3768307,38.7017015 L26.777025,38.7017015 L21.0012043,44.5999985 L15.261068,38.7017015 L10.6213796,38.7017015 C9.15416634,38.4308058 8.06365027,37.931182 7.34983142,37.2028299 C6.63601257,36.4744779 6.18606877,35.4022784 6,33.9862315 L6,13.7898616 Z"></path>',
            '<filter id="f1" x="0" y="0" width="46" height="52" filterUnits="userSpaceOnUse">',
            '<feOffset dy="1" input="SourceAlpha"/>',
            '<feGaussianBlur stdDeviation="2.5" result="blur"/>',
            '<feFlood flood-opacity="0.65"/>',
            '<feComposite operator="in" in2="blur"/>',
            '<feComposite in="SourceGraphic"/>',
            '</filter>',
            '</defs>',
	        '<g transform="translate(2 0)">',
		    '<use fill="#000" fill-opacity="1" filter="url(#f1)" xlink:href="#p1"></use>',
		    '<use stroke="-----STROKE-----" stroke-width="1" fill="-----FILL-----" xlink:href="#p1"></use>',
	        '<text font-family="monospace" font-size="17" fill="-----NUMBER_COLOR-----" x="21" y="29.5" text-anchor="middle">-----NUMBER-----</text>',
	        '</g>',
            '-----BEARING-----',
            '</svg>'
        ].join("")

        const markerSolarLightTowerTemplate = [
            '<svg width="40" height="46" viewBox="0 0 40 46" fill="none" xmlns="http://www.w3.org/2000/svg">',
            '<defs>',
            '<filter id="filter0_d_18_48" x="0" y="0" width="40.0024" height="45.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">',
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>',
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>',
            '<feOffset dy="1"/>',
            '<feGaussianBlur stdDeviation="2.5"/>',
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"/>',
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_18_48"/>',
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_18_48" result="shape"/>',
            '</filter>',
            '</defs>',
            '<g transform="scale(0.885)">',
            '<g transform="translate(-0.25, 0)">',
            '<g transform="translate(2.75, 5)">',
            '<g filter="url(#filter0_d_18_48)">',
            '<path fill="black" d="M5 8.78986C5.08013 7.44639 5.53008 6.34983 6.34983 5.50019C7.16959 4.65055 8.2601 4.15049 9.62138 4H30.3768C31.7349 4.23261 32.7845 4.73267 33.5257 5.50019C34.2669 6.26771 34.7591 7.36427 35.0024 8.78986V28.9862C34.8253 30.3076 34.333 31.3798 33.5257 32.2028C32.7184 33.0258 31.6688 33.5255 30.3768 33.7017H25.777L20.0012 39.6L14.2611 33.7017H9.62138C8.15417 33.4308 7.06365 32.9312 6.34983 32.2028C5.63601 31.4745 5.18607 30.4023 5 28.9862V8.78986Z"/>',
            '</g>',
            '<path fill="#D7D7D7" d="M20 3.5H28.5C32.366 3.5 35.5 6.63401 35.5 10.5V18.85H20V3.5Z"/>',
            '<path fill="white" d="M20 18.85H35.5V27.2C35.5 31.066 32.366 34.2 28.5 34.2H20V18.85Z"/>',
            '<path fill="white" d="M4.5 10.5C4.5 6.634 7.63401 3.5 11.5 3.5H20V18.85H4.5V10.5Z"/>',
            '<path fill="#D7D7D7" d="M4.5 18.85H20V34.2H11.5C7.63401 34.2 4.5 31.066 4.5 27.2V18.85Z"/>',
            '<path fill="white" d="M20 39.5V34H25.5L20 39.5Z"/>',
            '<path fill="#D7D7D7" d="M20 39.5V34H14.5L20 39.5Z"/>',
            '<path stroke="black" d="M5 8.78986C5.08013 7.44639 5.53008 6.34983 6.34983 5.50019C7.16959 4.65055 8.2601 4.15049 9.62138 4H30.3768C31.7349 4.23261 32.7845 4.73267 33.5257 5.50019C34.2669 6.26771 34.7591 7.36427 35.0024 8.78986V28.9862C34.8253 30.3076 34.333 31.3798 33.5257 32.2028C32.7184 33.0258 31.6688 33.5255 30.3768 33.7017H25.777L20.0012 39.6L14.2611 33.7017H9.62138C8.15417 33.4308 7.06365 32.9312 6.34983 32.2028C5.63601 31.4745 5.18607 30.4023 5 28.9862V8.78986Z"/>',
            '<text font-family="monospace" font-size="17" fill="#000" x="20" y="24" text-anchor="middle">-----NUMBER-----</text>',
            '</g>',
            '-----BEARING-----',
            '</g>',
            '</g>',
            '</svg>'
        ].join("")

        const markerQwsSensorTemplate = [
            '<svg width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.38 46.38" xmlns:xlink="http://www.w3.org/1999/xlink">',
            '<defs>',
            '<filter id="f1" x="-4" y="-4" filterUnits="userSpaceOnUse">',
            '<feOffset dx="-1" dy="1" input="SourceAlpha"/>',
            '<feGaussianBlur stdDeviation="2.5" result="blur"/>',
            '<feFlood flood-opacity="0.65"/>',
            '<feComposite operator="in" in2="blur"/>',
            '<feComposite in="SourceGraphic"/>',
            '</filter>',
            '</defs>',
            '<g transform="translate(4 1)">',
            '<g transform="translate(0 18) rotate(-45)">',
            '<rect x="0" y="0" width="26.43" height="26.43" fill="#000" filter="url(#f1)"/>',
            '<rect x="0" y="0" width="26.43" height="26.43" fill="-----FILL-----"/>',
            '</g>',
            '<polygon points="34.89 21.17 18.69 37.38 2.48 21.17 34.89 21.17" fill="-----FILL-----"/>',
            '<text text-anchor="middle" transform="translate(18.5 24.5)" font-size="17" fill="-----NUMBER_COLOR-----" font-family="monospace" style="isolation: isolate">-----NUMBER-----</text>',
            '<path stroke="-----STROKE-----" stroke-width="1" fill="-----FILL-----" transform="translate(-412.57 -593.71)" d="M431.25,595.12l17.28,17.28-17.28,17.27L414,612.4l17.27-17.28m0-1.41L412.57,612.4l18.68,18.68,18.69-18.68-18.69-18.69Z"/>',
            '</g>',
            '</svg>'
        ].join("")

        // const markerQwsSensorTemplateWithSub = [
        //     '<svg width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.38 46.38" xmlns:xlink="http://www.w3.org/1999/xlink">',
        //     '<defs>',
        //     '<filter id="f1" x="-4" y="-4" filterUnits="userSpaceOnUse">',
        //     '<feOffset dx="-1" dy="1" input="SourceAlpha"/>',
        //     '<feGaussianBlur stdDeviation="2.5" result="blur"/>',
        //     '<feFlood flood-opacity="0.65"/>',
        //     '<feComposite operator="in" in2="blur"/>',
        //     '<feComposite in="SourceGraphic"/>',
        //     '</filter>',
        //     '</defs>',
        //     '<g transform="translate(4 1)">',
        //     '<g transform="translate(0 18) rotate(-45)">',
        //     '<rect x="0" y="0" width="26.43" height="26.43" fill="#000" filter="url(#f1)"/>',
        //     '<rect x="0" y="0" width="26.43" height="26.43" fill="-----STROKE-----"/>',
        //     '</g>',
        //     '<polygon points="34.89 21.17 18.69 37.38 2.48 21.17 34.89 21.17" fill="#fff"/>',
        //     '<text text-anchor="middle" transform="translate(18.6 18)" font-size="13" font-weight="600" fill="#fff" font-family="monospace" style="isolation: isolate">-----NUMBER-----</text>',
        //     '<text text-anchor="middle" transform="translate(18.75 29.25)" font-size="9" font-weight="600" fill="#231f20" font-family="monospace" style="isolation: isolate">-----SUB-NUMBER-----</text>',
        //     '<path stroke="-----STROKE-----" stroke-width="1" fill="-----STROKE-----" transform="translate(-412.57 -593.71)" d="M431.25,595.12l17.28,17.28-17.28,17.27L414,612.4l17.27-17.28m0-1.41L412.57,612.4l18.68,18.68,18.69-18.68-18.69-18.69Z"/>',
        //     '</g>',
        //     '</svg>'
        // ].join("")

        const markerBearingTemplate = [
            '<g transform="translate(23 24)">',
            '<g transform="rotate(-----BEARINGSYM----- 0 0)">',
            '<g transform="translate(0 ------OFFSET-----)">',
            '<polygon stroke="#000" stroke-width="1.25" fill="-----BEARINGCOLOR-----" points="0 -21 -4.25 -11 4.25 -11"></polygon>',
            '</g>',
            '</g>',
            '</g>'
        ].join("")

        const markerBearingUnknownTemplate = [
            '<g>',
            '<path stroke="#000" stroke-width="1" fill="-----BEARINGCOLOR-----" d="M29.3890873,4.66864524 L27.9275488,3.20710678 L23.048097,8.08655858 L18.1686452,3.20710678 L16.7071068,4.66864524 L21.5865586,9.54809704 L16.7071068,14.4275488 L18.1686452,15.8890873 L23.048097,11.0096355 L27.9275488,15.8890873 L29.3890873,14.4275488 L24.5096355,9.54809704 L29.3890873,4.66864524 Z"></path>',
            '</g>'
        ].join("")

        const markerOldestTemplate = [
            '<svg width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">',
            '<defs>',
            '<polygon id="p" points="0 0 0 14 14 7"></polygon>',
            '</defs>',
            '<g fill="none" fill-rule="evenodd">',
            '<use fill="-----FILL-----" xlink:href="#p"></use>',
            '<path stroke="-----STROKE-----" stroke-width="1" d="M0.5,0.809016994 L0.5,13.190983 L12.881966,7 L0.5,0.809016994 Z"></path>',
            '</g>',
            '</svg>'
        ].join("")

        const markerTrucksEnterTemplate = [
            '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="46">',
            '<defs>',
            '<filter id="f1" x="5" y="5" width="36" height="36" filterUnits="userSpaceOnUse">',
            '<feOffset dy="1" input="SourceAlpha"/>',
            '<feGaussianBlur stdDeviation="2.5" result="blur"/>',
            '<feFlood flood-opacity="0.42"/>',
            '<feComposite operator="in" in2="blur"/>',
            '<feComposite in="SourceGraphic"/>',
            '</filter>',
            '</defs>',
            '<g filter="url(#f1)">',
            '<circle cx="13" cy="13" r="13" transform="translate(10 10)"/>',
            '</g>',
            '<circle cx="12" cy="12" r="12" transform="translate(11 11)" fill="-----FILL-----"/>',
            '<text font-family="monospace" font-weight="bold" font-size="15.5" kerning="0" fill="-----NUMBER_COLOR-----" x="23" y="28" text-anchor="middle">-----NUMBER-----</text>',
            '</svg>'
        ].join("")

        const clusterIcon = [
            '<svg fill="#646464" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">',
            '<circle cx="120" cy="120" opacity=".8" r="66" />',
            '<circle cx="120" cy="120" opacity=".4" r="84" />',
            '<circle cx="120" cy="120" opacity=".2" r="102" />',
            '<circle cx="120" cy="120" opacity=".1" r="120" />',
            '</svg>'
        ].join("")

        const color_message_board             = "#0069AA"
        const color_message_board_dark        = "#003f66"
        const color_message_board_light       = "#35a7ed"
        const color_speed_limit_trailer       = "#a422b3"
        const color_speed_limit_trailer_dark  = "#54115c"
        const color_speed_limit_trailer_light = "#ed63ff"
        const color_tracker                   = "#2b9602"
        const color_tracker_dark              = "#1a5a01"
        const color_tracker_light             = "#68db3b"
        const color_arrow_board               = "#a17000"
        const color_arrow_board_dark          = "#523800"
        const color_arrow_board_light         = "#e6b037"
        const color_beacon_on                 = "#f6cb45"
        const color_beacon_off                = "#7f7f7f"
        const color_beacon_dark               = "#000000"
        const color_beacon_medium             = "#dddddd"
        const color_qws_sensor                = "#437639"
        const color_qws_sensor_dark           = "#305428"
        const color_afad_gate                 = "#FF1807"
        const color_afad_gate_dark            = "#222222"
        const color_afad_gate_light           = "#FF847B"
        const color_marker                    = "#e36b00"
        const color_marker_dark               = "#793900"
        const color_marker_light              = "#feb676"

        const buildPin = function(device, marker_number, color, color_dark) {

            let svg = markerTemplate
            let bearingColor = "#FFF"

            if (device.meta.isTrackerTrucksEnter) {

                if (device.telemetry.beacons_on) {
                    svg = markerTrucksEnterTemplate.replaceAll("-----NUMBER_COLOR-----", "#000")
                } else {
                    svg = markerTrucksEnterTemplate.replaceAll("-----NUMBER_COLOR-----", "#FFF")
                }
            }

            if (device.meta.isTrackerBeaconTrailer) {

                if (device.telemetry.beacons_on) {
                    svg = markerTemplate.replaceAll("-----NUMBER_COLOR-----", "#000")
                } else {
                    svg = markerTemplate.replaceAll("-----NUMBER_COLOR-----", "#FFF")
                }
            }

            if (device.meta.isTrackerQwsSensor) {

                if (device.hasOwnProperty("pinColors") && device.pinColors.name === "yellow") {
                    svg = markerQwsSensorTemplate.replaceAll("-----NUMBER_COLOR-----", "#000")
                } else {
                    svg = markerQwsSensorTemplate.replaceAll("-----NUMBER_COLOR-----", "#FFF")
                }
                // if (device.gps.hasOwnProperty("subIndex")) {
                //     svg = markerQwsSensorTemplateWithSub
                // }
            }

            if (device.meta.isTrackerSolarLightTower) {
                bearingColor = "#000"
                svg = markerSolarLightTowerTemplate
            }

            svg = svg.replaceAll("-----NUMBER_COLOR-----", "#FFF").replaceAll("-----NUMBER-----", marker_number).replaceAll("-----FILL-----", color).replaceAll("-----STROKE-----", color_dark)

            if (device.gps.hasOwnProperty("subIndex")) {
                svg = svg.replaceAll("-----SUB-NUMBER-----", device.gps.subIndex)
            }

            if (device.telemetry.bearing === undefined || !device.telemetry.bearing.hasOwnProperty("degrees")) {

                svg = svg.replaceAll("-----BEARING-----", "")

            } else if (device.telemetry.bearing.degrees < 0 || device.telemetry.bearing.degrees > 359 || (device.meta.isTrackerRCUArrowBoard && device.telemetry.display.stowed)) {

                svg = svg.replaceAll("-----BEARING-----", markerBearingUnknownTemplate).replaceAll("-----BEARINGCOLOR-----", bearingColor)

            } else {

                let degrees = device.telemetry.bearing.degrees

                // Calculate Bearing Indicator Offset
                //
                // The bearing indicator on the map icon roughly follows the shape of the map icon (rounded rect)
                // As the rotation is circular, an offset value is required to push/pull the indicator as it nears corners
                // The offset value is derived from the bearing degrees using a cubic non-linear curve estimation
                // The magic numbers can be calculated using the /resources/bearing-offset.xls document
                // by using the pre-determined first-five offset values
                //
                // Formula Source:
                // https://newtonexcelbach.com/2011/01/19/using-linest-for-non-linear-curve-fitting/

                let offset    = 0
                const precision = 2

                // Magic Numbers

                const A = -0.000058527663466
                const B =  0.003950617283951
                const C =  0.007407407407408
                const D =  1

                // Normalize degrees value to fit within first 1/8th (0 - 45)

                switch (true) {

                    case degrees <= 45:
                        break

                    case degrees <= 90:
                        degrees = 90 - degrees
                        break
                    case degrees <= 135:
                        degrees = degrees - 90
                        break
                    case degrees <= 180:
                        degrees = 180 - degrees
                        break
                    case degrees <= 225:
                        degrees = degrees - 180
                        break
                    case degrees <= 270:
                        degrees = 270 - degrees
                        break
                    case degrees <= 315:
                        degrees = degrees - 270
                        break
                    case degrees <= 360:
                        degrees = 360 - degrees
                        break
                }

                offset = Math.round(((A * Math.pow(degrees, 3)) + (B * Math.pow(degrees, 2)) + (C * degrees) + D) * Math.pow(10, precision)) / Math.pow(10, precision)

                svg = svg.replaceAll("-----BEARING-----", markerBearingTemplate).replaceAll("-----BEARINGSYM-----", device.telemetry.bearing.degrees).replaceAll("-----OFFSET-----", offset).replaceAll("-----BEARINGCOLOR-----", bearingColor)

            }

            return svg
        }

        let displayedMarkers           = []
        let displayedPositionedMarkers = []
        let displayedHeatData          = []
        let displayedMarkerLabels      = []
        let displayedCluster           = undefined
        let displayedWzPath            = undefined
        let displayedHeatPaths         = []
        let heatDevices                = []

        service.setMarkers = function(reset, map, devices, includeLabels, includeClusters, includePath, includeHeat) {

            for (const marker of displayedMarkers) {
                marker.setMap(null)
            }

            for (const marker of displayedMarkerLabels) {
                marker.setMap(null)
            }

            if (displayedCluster !== undefined && typeof displayedCluster.clearMarkers === "function") {
                displayedCluster.clearMarkers()
            }

            if (displayedWzPath !== undefined && typeof displayedWzPath.setMap === "function") {
                displayedWzPath.setMap(null)
            }

            for (const displayedHeatPath of displayedHeatPaths) {
                if (typeof displayedHeatPath.setMap === "function") {
                    displayedHeatPath.setMap(null)
                }
            }

            displayedMarkers           = []
            displayedMarkerLabels      = []
            displayedPositionedMarkers = []
            displayedHeatData          = []
            displayedCluster           = undefined
            displayedWzPath            = undefined
            displayedHeatPaths         = []
            heatDevices                = []

            const bounds = new google.maps.LatLngBounds()

            const info_windows = []

            let hasMarker     = false
            let marker_number = 1

            let lat_long = new google.maps.LatLng(0, 0)
            let badGPS = false
            let heatColor = "green"

            for (const device of devices) {

                if (device.gps.isValid && device.gps.notZero) {

                    let pin_width  = 46
                    let pin_height = 52

                    // let pin_width  = 58
                    // let pin_height = 58

                    hasMarker = true

                    let color      = color_message_board
                    let color_dark = color_message_board_dark

                    lat_long = new google.maps.LatLng(device.gps.lat, device.gps.lon)

                    badGPS = badGPS || device.gps.lat >= 75  || device.gps.lat <= -75  || (device.gps.lat <= 15 && device.gps.lat >= -15)
                    badGPS = badGPS || device.gps.lon >= 165 || device.gps.lon <= -165 || (device.gps.lon <= 15 && device.gps.lon >= -15)

                    let info_window = undefined

                    let image        = ""
                    let bearing_text = ""

                    if (device.meta.isMessageBoard) {

                        if (device.meta.isMessageBoardSpeedLimitTrailer) {

                            color      = color_speed_limit_trailer
                            color_dark = color_speed_limit_trailer_dark

                            if (device.initialized) {
                                image = '<img src="' + imagesService.getDisplayImage(device) + '" alt="Speed Preview" class="preview-thumb push-down-small"/>'
                            }

                            if (device.telemetry.bearing !== undefined) {
                                bearing_text = '<p class="popup-subtitle">Bearing: ' + $rootScope.getBearingName(device.telemetry.bearing.degrees) + '</p>'
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/message-board/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<p class="popup-subtitle">' + (device.device.model_number || '') + '</p>' +
                                    bearing_text +
                                    '<hr/>' +
                                    image +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/message-board/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                        } else {

                            color      = color_message_board
                            color_dark = color_message_board_dark

                            if (device.hasOwnProperty("pinColors")) {
                                color      = device.pinColors.lightDark[0]
                                color_dark = device.pinColors.lightDark[1]
                            }

                            let hasPreview = false

                            if (device.initialized) {

                                if (device.hasOwnProperty("messageMulti")) {
                                    hasPreview = true
                                    image = "<div id='preview-" + device.device.id + "'></div><br />"
                                } else {
                                    image = '<img src="' + imagesService.getDisplayImage(device) + '" alt="Message Preview" class="preview-thumb push-down-small"/>'
                                }
                            }

                            if (device.telemetry.bearing !== undefined) {
                                bearing_text = '<p class="popup-subtitle">Bearing: ' + $rootScope.getBearingName(device.telemetry.bearing.degrees) + '</p>'
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/message-board/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<p class="popup-subtitle">' + (device.device.model_number || '') + '</p>' +
                                    bearing_text +
                                    '<hr/>' +
                                    image +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/message-board/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                            if (hasPreview) {

                                google.maps.event.addListener(info_window, 'domready', async () => {

                                    const previewController = await messagePreviewService.getController(device)

                                    if (previewController !== undefined) {

                                        messagePreviewService.generatePreviewFromMulti(previewController, device.messageMulti, "preview-" + device.device.id)

                                        google.maps.event.addListenerOnce(info_window, 'closeclick', () => {
                                            previewController.dispose()
                                        })
                                    }
                                })
                            }
                        }

                    } else if (device.meta.isTracker) {

                        if (device.meta.isTrackerArrowBoard) {

                            color      = color_arrow_board
                            color_dark = color_arrow_board_dark

                            if (device.initialized) {
                                image = '<img src="' + device.telemetry.image_url + '" alt="Preview" class="preview-thumb push-down-small"/>'
                            }

                            if (device.telemetry.bearing !== undefined) {
                                bearing_text = '<p class="popup-subtitle">Bearing: ' + $rootScope.getBearingName(device.telemetry.bearing.degrees) + '</p>'
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/tracker/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<p class="popup-subtitle">' + (device.device.model_number || '') + '</p>' +
                                    bearing_text +
                                    '<hr/>' +
                                    image +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/tracker/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                        } else if (device.meta.isTrackerAFADGate) {

                            color      = color_afad_gate
                            color_dark = color_afad_gate_dark

                            if (device.initialized) {
                                // image = '<img src="' + device.telemetry.image_url + '" alt="Preview" class="preview-thumb push-down-small"/>'
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/tracker/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<hr/>' +
                                    image +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/tracker/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                        } else if (device.meta.isTrackerTrucksEnter || device.meta.isTrackerBeaconTrailer) {

                            if (device.meta.isTrackerTrucksEnter) {
                                pin_width  = 46
                                pin_height = 46
                            }

                            color      = color_beacon_off
                            color_dark = color_beacon_dark

                            if (device.telemetry.beacons_on) {
                                color = color_beacon_on
                            }

                            if (device.initialized) {
                                image = '<img src="' + device.telemetry.image_url + '" alt="Preview" class="preview-thumb push-down-small"/>'
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/tracker/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<p class="popup-subtitle">' + (device.device.model_number || '') + '</p>' +
                                    '<hr/>' +
                                    image +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/tracker/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                        } else if (device.meta.isTrackerQwsSensor) {

                            pin_width  = 50
                            pin_height = 50

                            color      = color_qws_sensor
                            color_dark = color_qws_sensor_dark

                            if (device.hasOwnProperty("pinColors")) {
                                color      = device.pinColors.lightDark[0]
                                color_dark = device.pinColors.lightDark[1]
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/tracker/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<p class="popup-subtitle">' + (device.device.model_number || '') + '</p>' +
                                    '<hr/>' +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/tracker/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                        } else if (device.meta.isTrackerMarker) {

                            color      = color_marker
                            color_dark = color_marker_dark

                            if (device.initialized) {
                                // image = '<img src="' + device.telemetry.image_url + '" alt="Preview" class="preview-thumb push-down-small"/>'
                            }

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/tracker/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<hr/>' +
                                    image +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/tracker/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )

                        } else {

                            color      = color_tracker
                            color_dark = color_tracker_dark

                            info_window = new google.maps.InfoWindow({
                                content:
                                    '<div class="map-popup">' +
                                    '<h3 class="popup-title"><a href="/tracker/id/' + device.id + '/details">' + device.name + '</a></h3>' +
                                    '<p class="popup-subtitle">' + (device.device.model_number || '') + '</p>' +
                                    '<hr/>' +
                                    '<div class="btn-wrap">' +
                                    '<a class="btn btn-default" href="/tracker/id/' + device.id + '/details">View / Edit</a>' +
                                    '</div>' +
                                    '</div>'
                                }
                            )
                        }
                    }

                    info_windows.push(info_window)

                    const svg = buildPin(device, marker_number, color, color_dark)

                    let marker = new google.maps.Marker({
                        position: lat_long,
                        map: map,
                        title: device.name,
                        icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
                            scaledSize: new google.maps.Size(pin_width, pin_height)
                        },
                        optimized: true
                    })

                    if (includePath && device.hasOwnProperty("display_position") && device.display_position > 0) {
                        displayedPositionedMarkers.push(marker)
                    }

                    if (includeHeat) {
                        heatDevices.push({
                            device: device,
                            marker: marker
                        })
                    }

                    displayedMarkers.push(marker)

                    marker_number++

                    let markerLabel = new MarkerLabel(lat_long, device, includeLabels)
                    markerLabel.setMap(map)
                    marker.customMarkerLabel = markerLabel

                    displayedMarkerLabels.push(markerLabel)

                    google.maps.event.addListener(marker, "click", () => {
                        for (const infoWindow of info_windows) {
                            infoWindow.close()
                        }
                        info_window.open(map, marker)
                    })

                    bounds.extend(lat_long)

                }
            }

            markerLabelsVisible = includeLabels

            if (hasMarker === false) {

                map.setZoom(2)
                return

            }

            if (includeHeat && heatDevices.length === -1) {

                heatDevices = heatDevices.reverse()

                for (const heatDevice of heatDevices) {

                    if (heatDevice.device.is_qws_input) {

                        heatColor = heatDevice.device.mapColor
                        // heatColor = "green"

                        // if (!heatDevice.device.active) {
                        //     heatColor = "black"
                        // } else if (heatDevice.device.qws_sensor.average_speed <= 25) {
                        //     heatColor = "red"
                        // } else if (heatDevice.device.qws_sensor.average_speed <= 45) {
                        //     heatColor = "yellow"
                        // }
                    }

                    displayedHeatData.push({
                        marker: heatDevice.marker,
                        heat: heatColor
                    })
                }

                const paths = []

                let path = {
                    markers: [],
                    heat:    undefined
                }

                for (const heat of displayedHeatData) {

                    if (path.markers.length > 0 && heat.heat !== path.heat) {
                        path.markers.push(heat.marker)
                        paths.push(path)
                        path = {
                            markers: [],
                            heat:    undefined
                        }
                    }

                    path.markers.push(heat.marker)
                    path.heat = heat.heat

                }

                if (path.heat !== undefined) {
                    paths.push(path)
                }

                for (const heat of paths) {

                    let pathPositions = []

                    for (const marker of heat.markers) {
                        pathPositions.push(marker.position)
                    }

                    const displayedHeatPath = new google.maps.Polyline({
                        path: pathPositions,
                        geodesic: false,
                        strokeOpacity: 1,
                        strokeColor: heat.heat,
                        strokeWeight: 8,
                        map: map
                    })

                    displayedHeatPaths.push(displayedHeatPath)

                }
            }

            if (includePath && displayedPositionedMarkers.length > 1) {

                const pathPositions = []

                for (const marker of displayedPositionedMarkers) {
                    pathPositions.push(marker.position)
                }

                displayedWzPath = new google.maps.Polyline({
                    path: pathPositions,
                    geodesic: false,
                    strokeOpacity: 0,
                    map: map,
                    icons: [
                        {
                            repeat: "10px",
                            offset: "0",
                            icon: {
                                path:          "M2,2,0,4ZM0,0,2,2Z",
                                strokeColor:   "#ED9944",
                                strokeOpacity: 0.25,
                                scale:         2,
                                rotation:      270,
                                anchor:        new google.maps.Point(1.5, 1.5)
                            }
                        },
                        {
                            repeat: "10px",
                            offset: "0",
                            icon: {
                                path:          "M2,2,0,4ZM0,0,2,2Z",
                                strokeColor:   "#ED9944",
                                strokeOpacity: 0.5,
                                scale:         2,
                                rotation:      270,
                                anchor:        new google.maps.Point(1, 1.5)
                            }
                        },
                        {
                            repeat: "10px",
                            offset: "0",
                            icon: {
                                path:          "M2,2,0,4ZM0,0,2,2Z",
                                strokeColor:   "#ED9944",
                                strokeOpacity: 1,
                                scale:         2,
                                rotation:      270,
                                anchor:        new google.maps.Point(0.5, 1.5)
                            }
                        },
                        {
                            repeat: "10px",
                            offset: "0",
                            icon: {
                                path:          "M2,2,0,4ZM0,0,2,2Z",
                                strokeColor:   "#D86C00",
                                strokeOpacity: 1,
                                scale:         2,
                                rotation:      270,
                                anchor:        new google.maps.Point(0, 1.5)
                            }
                        },
                        {
                            repeat: "50px",
                            offset: "0",
                            icon: {
                                path:          "M2,2,0,4ZM0,0,2,2Z",
                                strokeColor:   "#000",
                                strokeOpacity: 1,
                                scale:         2,
                                rotation:      270,
                                anchor:        new google.maps.Point(0, 1.5)
                            }
                        }
                    ]
                })
            }

            if (includeClusters && displayedMarkers.length > 1) {

                const clusterOptions = {
                    averageCenter: true,
                    maxZoom:       17,
                    gridSize:      36,
                    clusterClass:  "mapClusterPin",
                    styles: [
                        {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(clusterIcon),
                            height:     70,
                            width:      70,
                            textColor:  "white",
                            textSize:   14,
                            anchorText: [27,0]
                        }
                    ],
                    calculator: (markers, styleCount) => {

                        for (const marker of markers) {
                            if (marker.hasOwnProperty("customMarkerLabel")) {
                                marker.customMarkerLabel.inCluster = true
                                marker.customMarkerLabel.hide()
                            }
                        }

                        return {
                            text: markers.length,
                            index: styleCount - 1
                        }
                    }
                }

                displayedCluster = new MarkerClusterer(map, displayedMarkers, clusterOptions)

                const resetLabels = () => {

                    for (const marker of displayedMarkers) {
                        if (marker.hasOwnProperty("customMarkerLabel")) {
                            marker.customMarkerLabel.inCluster = false
                            if (!markerLabelsVisible) {
                                marker.customMarkerLabel.hide()
                            } else {
                                marker.customMarkerLabel.show()
                            }
                        }
                    }
                }

                google.maps.event.addListener(displayedCluster, "clusteringbegin", resetLabels)

            } else if (displayedMarkers.length === 1) {

                map.setCenter(lat_long)

            }

            if (reset) {

                const performZoomReset = () => {

                    const currentZoom = map.getZoom()

                    if (currentZoom === 0 || badGPS) {
                        map.setZoom(2)
                    } else if (currentZoom === 1 || currentZoom > 17) {
                        map.setZoom(17)
                    }
                }

                google.maps.event.addListenerOnce(map, "zoom_changed", performZoomReset)

                map.fitBounds(bounds)

                return

            }
        }

        let markerLabelsVisible = true

        service.toggleMarkerLabels = function() {

            markerLabelsVisible = !markerLabelsVisible

            for (const markerLabel of displayedMarkerLabels) {

                if (!markerLabel.inCluster) {

                    if (!markerLabelsVisible) {
                        markerLabel.hide()
                    } else {
                        markerLabel.show()
                    }
                }
            }
        }

        let displayedHistoryMarkers = []
        let displayedHistoryInfos   = []
        let displayedHistoryTrails  = []

        /**
            Set single marker
            @param map
            @param device
            @param history
         **/
        service.setSingleMarker = function(reset, map, device, history, connectCurrent) {

            for (const marker of displayedHistoryMarkers) {
                marker.setMap(null)
            }

            for (const info of displayedHistoryInfos) {
                info.setMap(null)
            }

            for (const trail of displayedHistoryTrails) {
                trail.setMap(null)
            }

            displayedHistoryMarkers = []
            displayedHistoryInfos   = []
            displayedHistoryTrails  = []

            if (history.length === 0 && device.hasOwnProperty("updated_at") && device.hasOwnProperty("gps") && device.gps.hasOwnProperty("lat") && device.gps.hasOwnProperty("lon")) {

                history.push({
                    updated_at: device.updated_at,
                    gps: {
                        lat: device.gps.lat,
                        lon: device.gps.lon
                    }
                })
            }

            if (history.length === 0) {

                return

            }

            let bounds            = new google.maps.LatLngBounds()
            let historyMarkers    = []
            let historyMarkersMax = 65
            let infoWindows       = []
            let currentLocation   = undefined
            let isCurrentLocation = false
            let prevLat           = 99999
            let prevLon           = 99999
            let trailZoomMax      = 10
            let trailData         = []

            let fillColor       = color_message_board
            let strokeColor     = color_message_board_dark
            let oldestFillColor = color_message_board_light
            let fillColorTrail  = color_message_board

            if (device.meta.isMessageBoardSpeedLimitTrailer) {

                fillColor       = color_speed_limit_trailer
                strokeColor     = color_speed_limit_trailer_dark
                oldestFillColor = color_speed_limit_trailer_light
                fillColorTrail  = color_speed_limit_trailer

            } else if (device.meta.isTracker) {

                fillColor       = color_tracker
                strokeColor     = color_tracker_dark
                oldestFillColor = color_tracker_light
                fillColorTrail  = color_tracker

                if (device.meta.isTrackerArrowBoard) {

                    fillColor       = color_arrow_board
                    strokeColor     = color_arrow_board_dark
                    oldestFillColor = color_arrow_board_light
                    fillColorTrail  = color_arrow_board

                } else if (device.meta.isTrackerAFADGate) {

                    fillColor       = color_afad_gate
                    strokeColor     = color_afad_gate_dark
                    oldestFillColor = color_afad_gate_light
                    fillColorTrail  = color_afad_gate

                } else if (device.meta.isTrackerTrucksEnter || device.meta.isTrackerBeaconTrailer) {

                    fillColor       = color_beacon_off
                    strokeColor     = color_beacon_dark
                    oldestFillColor = color_beacon_on
                    fillColorTrail  = color_beacon_off

                    if (device.telemetry.beacons_on) {
                        fillColor = color_beacon_on
                    }

                } else if (device.meta.isTrackerQwsSensor) {

                    fillColor       = color_qws_sensor
                    strokeColor     = color_qws_sensor_dark

                } else if (device.meta.isTrackerMarker) {

                    fillColor       = color_marker
                    strokeColor     = color_marker_dark
                    oldestFillColor = color_marker_light
                    fillColorTrail  = color_marker

                }
            }

            let iconTrail = {
                path:          google.maps.SymbolPath.CIRCLE,
                fillColor:     fillColorTrail,
                fillOpacity:   0.5,
                strokeColor:   "#000",
                strokeOpacity: 0.7,
                strokeWeight:  0.5,
                scale:         6
            }

            google.maps.InfoWindow.prototype.isHidden = true

            google.maps.InfoWindow.prototype.show = function(map, marker) {
                if (this.isHidden) {
                    this.isHidden = false
                    this.open(map, marker)
                }
            }
            google.maps.InfoWindow.prototype.hide = function() {
                this.isHidden = true
                this.close()
            }

            const coordIsDuplicate = function(first, second) {
                // https://gis.stackexchange.com/questions/8650/measuring-accuracy-of-latitude-and-longitude#8674
                // Is duplicate if within roughly 16.5 meters (10,000th decimal place == approximately 11 meters)
                return Math.abs(first - second) < 0.00015
            }

            let addInfo = function(marker, updatedDateTime) {

                // Includes tricks to minimize flickering (isHidden, timeouts, etc)

                let infoWindow = new google.maps.InfoWindow({
                    disableAutoPan: true,
                    content:        '<div class="map-popup">' + updatedDateTime + '</div>'
                })

                infoWindows.push(infoWindow)

                let closeTimer = undefined

                let show = function() {
                    clearTimeout(closeTimer)
                    infoWindow.show(map, marker)
                    infoWindows.forEach((otherInfoWindow) => {
                        if (infoWindow !== otherInfoWindow) {
                            otherInfoWindow.hide()
                        }
                    })
                }

                let hide = function() {
                    closeTimer = setTimeout(function() {
                        infoWindow.hide()
                    }, 500)
                }

                google.maps.event.addListener(marker, "mouseover", show)

                google.maps.event.addListener(marker, "click", show)

                google.maps.event.addListener(marker, "mouseout", hide)

                google.maps.event.addListener(infoWindow, "closeclick", () => {
                    infoWindow.isHidden = true
                })

                displayedHistoryMarkers.push(marker)
                displayedHistoryInfos.push(infoWindow)

            }

            for (let i = 0; i < history.length; i++) {

                if (historyMarkers.length === historyMarkersMax) {
                    break
                }

                let value = history[i]

                if (value.hasOwnProperty("updated_at") && value.hasOwnProperty("gps") && value.gps.hasOwnProperty("lat") && value.gps.hasOwnProperty("lon")) {

                    value.updatedDateTime = $rootScope.presentDateTime(value.updated_at, "NumericLongDate", device.device.timezone_iana)

                    if (coordIsDuplicate(value.gps.lat, prevLat) && coordIsDuplicate(value.gps.lon, prevLon)) {
                        continue
                    }

                    let gps = value.gps

                    if (!gps.hasOwnProperty("isValid")) {
                        gps = $rootScope.processGPS(value).gps
                    }

                    prevLat = gps.lat
                    prevLon = gps.lon

                    if (!isCurrentLocation && gps.notZero) {

                        let location = new google.maps.LatLng(gps.lat, gps.lon)

                        bounds.extend(location)

                        isCurrentLocation = true
                        currentLocation   = location

                        let width  = 46
                        let height = 52

                        if (device.meta.isTrackerTrucksEnter) {
                            width  = 46
                            height = 46
                        }

                        if (device.meta.isTrackerQwsSensor) {
                            width  = 50
                            height = 50
                        }

                        const iconCurrent = buildPin(device, 1, fillColor, strokeColor)

                        const marker = new google.maps.Marker({
                            position:  location,
                            map:       map,
                            optimized: false,
                            zIndex:    google.maps.Marker.MAX_ZINDEX + history.length + 1,
                            icon:      { url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(iconCurrent), scaledSize: new google.maps.Size(width, height) }
                        })
                        addInfo(marker, value.updatedDateTime)
                    }

                    if ((connectCurrent || i > 0) && history.length > 1 && gps.isValid && gps.notZero) {

                        historyMarkers.push([gps, value.updatedDateTime])

                    }
                }
            }

            let zIndex = google.maps.Marker.MAX_ZINDEX + historyMarkers.length

            for (let i = 0; i < historyMarkers.length; i++) {

                let gps             = historyMarkers[i][0]
                let updatedDateTime = historyMarkers[i][1]
                let location        = new google.maps.LatLng(gps.lat, gps.lon)

                if (trailData.length < trailZoomMax) {
                    bounds.extend(location)
                }

                trailData.push({
                    lat: Number(gps.lat),
                    lng: Number(gps.lon)
                })

                zIndex = zIndex - 1
                let icon = iconTrail

                if (historyMarkers.length > 2 && i === historyMarkers.length - 1) {

                    // Oldest trail marker

                    let iconOldest = markerOldestTemplate.replaceAll("-----FILL-----", oldestFillColor).replaceAll("-----STROKE-----", strokeColor)
                    icon = { url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(iconOldest), anchor: new google.maps.Point(16, 7) }
                    zIndex = google.maps.Marker.MAX_ZINDEX + historyMarkers.length

                }

                let marker = new google.maps.Marker({
                    position:  location,
                    map:       map,
                    optimized: false,
                    zIndex:    zIndex,
                    icon:      icon
                })

                addInfo(marker, updatedDateTime)

            }

            if (trailData.length > 0) {

                let trail = new google.maps.Polyline({
                    path:          trailData,
                    geodesic:      true,
                    strokeColor:   "#000",
                    strokeOpacity: 0.75,
                    strokeWeight:  0.5,
                    icons: [
                        {
                            icon: {
                                path:          "M 0,-1 0,1",
                                strokeColor:   fillColorTrail,
                                strokeOpacity: 1,
                                scale:         2
                            },
                            offset: "0",
                            repeat: "10px"
                        }
                    ]
                })

                trail.setMap(map)

                displayedHistoryTrails.push(trail)

            }

            console.debug("GPS Trail Locations: " + trailData.length)

            if (reset) {

                const performZoomReset = () => {

                    const currentZoom = map.getZoom()

                    if (currentZoom < 2 || currentZoom > 17) {

                        let newZoom = 17

                        if (currentLocation && currentLocation.equals(new google.maps.LatLng(0, 0))) {
                            newZoom = 2
                        }

                        map.setZoom(newZoom)
                    }
                }

                google.maps.event.addListenerOnce(map, "zoom_changed", performZoomReset)

                map.fitBounds(bounds)

                return

            }

            const _bounds = map.getBounds()

            if (currentLocation && (_bounds === undefined || !_bounds.contains(currentLocation))) {
                map.setCenter(currentLocation)
            }
        }

        /**
            Set google marker geofence
            @param map
            @param device
         **/
        service.setGeofence = function(map, device) {

            if (device.gps.geofence_center_lat !== null && device.gps.geofence_center_lat !== undefined) {

                // Miles conversion to Meters
                let gpsRadius = device.gps.geofence_radius * 1609.34

                if (device.gps.geofence_units == "km") {
                    // Kilometers conversion to Meters
                    gpsRadius = device.gps.geofence_radius * 1000
                }

                let color = "#00AA24"

                if (device.meta.isTracker) {
                    color = "#0024AA"
                }

                new google.maps.Circle({
                    map:           map,
                    radius:        gpsRadius,
                    strokeColor:   color,
                    strokeOpacity: 0.75,
                    strokeWeight:  2,
                    fillColor:     color,
                    fillOpacity:   0.25,
                    center:        {
                        lat: device.gps.geofence_center_lat || 0,
                        lng: device.gps.geofence_center_lon || 0
                    }
                })
            }
        }

        return service
    }
})()
